import React, {Component} from 'react';
import {NavLink, withRouter} from "react-router-dom";
import {withAlert} from 'react-alert';
import {getRequest} from "../routes/Routes";
import '../assets/css/Home.css';
import Loading from "../components/Loading";

class Partners extends Component {
    constructor(props) {
        super(props);
        this.state = {partners: [], loading: true};
    }

    componentDidMount() {
        if (this.props.partners) {
            this.setState({partners: this.props.partners, loading: false});
        } else {
            this.loadPartners();
        }
    }

    render() {
        return (
            this.state.loading ?
                <Loading/>
                : !this.props.partners ?
                <div className="container category-list partner-list">
                    <h1 className="heading">Partners</h1>
                    <hr/>
                    {this.getPartnerBody()}
                </div>
                : this.getPartnerBody()
        );
    }

    getPartnerBody = () => {
        let firstColumn = [];
        let secondColumn = [];
        let thirdColumn = [];
        this.state.partners.forEach((partner, index) => {
            if ((index + 1) % 3 === 0) {
                thirdColumn.push(this.getPartnerCode(partner, index))
            } else if ((index + 1) % 2 === 0) {
                secondColumn.push(this.getPartnerCode(partner, index))
            } else {
                firstColumn.push(this.getPartnerCode(partner, index))
            }
        });

        return (
            <div className="d-flex bd-highlight w-100">
                <div className="p-2 flex-fill bd-highlight">
                    {firstColumn}
                </div>
                <div className="p-2 flex-fill bd-highlight">
                    {secondColumn}
                </div>
                <div className="p-2 flex-fill bd-highlight">
                    {thirdColumn}
                </div>
            </div>
        );
    };

    getPartnerCode = (partner, index) => {
        return (
            <div key={index} className="category-item">
                <NavLink className="nav-link" to={"/partner/" + partner.name}>
                    <img src={partner.image_url} alt={partner.name}/>
                    <div className="category-item-name">{partner.name}</div>
                </NavLink>
            </div>
        );
    };

    loadPartners = () => {
        getRequest('/api/partners').then(response => {
            if (response.status === 200) {
                if (response.data.error) {
                    this.props.alert.error(response.data.message);
                } else {
                    this.setState({
                        partners: this.props.home ? response.data.partners.splice(0, 3) : response.data.partners,
                        loading: false
                    });
                }
            } else {
                this.props.alert.error(response.data.message);
            }
        });
    };
}

export default withAlert()(withRouter(Partners));